import { render } from "./quizz.vue?vue&type=template&id=2ebf395c"
import script from "./quizz.vue?vue&type=script&lang=js"
export * from "./quizz.vue?vue&type=script&lang=js"

import exportComponent from "/Users/baptiste/P_8678-Amis-des-musees-1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__